import { Group, Modal, Stack, Text, Title } from "@mantine/core"
import { IconCheck } from "@tabler/icons-react"

import { Button } from "../../atoms/Button/Button"

type Props = {
  opened: boolean
  onClose: () => void
  title: string
  description: string
  successButtonLabel: string
}

export const SuccessModal = ({
  opened,
  onClose,
  title,
  description,
  successButtonLabel,
}: Props) => {
  return (
    <Modal opened={opened} onClose={onClose} size="lg">
      <Modal.Header>
        <Group>
          <Title order={3}>{title}</Title>
          <IconCheck size={24} color="green" />
        </Group>
      </Modal.Header>
      <Modal.Body>
        <Stack>
          <Text>{description}</Text>
          <Button w="100%" onClick={onClose} size="sm">
            {successButtonLabel}
          </Button>
        </Stack>
      </Modal.Body>
    </Modal>
  )
}
